<template>
  <div class="flex items-center h-full">
    <toggle-button
      :value="params.data.actionData.toggle"
      :color="{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}"
      class=""
      @change="handleChange"
    />
  </div>
</template>
<script>
import { update_user } from '@/api/user'
import { mapActions } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: 'ToggleActions',
  components: {
    ToggleButton
  },
  props: {
    // localValue: actionData,
  },
  mounted () {
    this.action = this.params.data.actionData
    this.toggle = this.params.data.actionData.toggle
  },
  data () {
    return {
      action: {},
      toggle: null
    }
  },
  methods: {
    ...mapActions([
      'SET_DELETE_ID',
      'SET_VIEW_LEADS_SIDEBAR',
      'SET_VIEW_LEADS_SIDEBAR_DATA',
      'SET_LEADS_TOGGLE_DATA'
    ]),
    async handleChange () {
      
      try {
        
        this.params.data.is_active = this.params.data.actionData.toggle ? 0 : 1
        const user_id = this.params.data.basic_details.operation_user_id


        const payload = {
          active_user: this.params.data.actionData.toggle ? 0 : 1

        }
        
        const customerId = this.$store.getters.customerId

        
        update_user(user_id, payload, customerId)
        // 
        const storePayload = {
          row_details: this.params.data,
          toggle: !this.params.data.actionData.toggle
        }
        
        this.SET_LEADS_TOGGLE_DATA(storePayload)
        const msg = !this.params.data.actionData.toggle ? 'Staff activated successfully' : 'Staff deactivated successfully'
        this.$vs.notify({
          title: 'Success',
          text: msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        
        this.$vs.notify({
          title: 'Warning',
          text: e,
          ...this.warnProp()
        })
      }
    }
  }
}
</script>
